<template>
  <div>
    <loader  v-if="!loaded"></loader>
    <mdc-dialog class="dro-modal"
                v-if="loaded"
                v-model="isOpen"
                :title="'dro.title' | trans"
                @cancel="close"
                @close="close"
                :class="{'fullscreen-dialog' : isMobile}">
      <div class="close-cross" @click="close()" v-if="!isMobile">
        <mdc-icon icon="close"></mdc-icon>
      </div>
      <settings-form :modalView=modalView
                     :settings="form"
                     v-on:session-settings-set="onSessionSettingsSet"
                     v-on:close="close">
      </settings-form>
    </mdc-dialog>
  </div>


</template>

<script>

  import {mapActions, mapGetters, mapState} from 'vuex';
  import Loader from '../../loader/components/Loader';
  import {loadDroInitData} from '../../../mixins/loadDroInitData';
  import SettingsForm from '../../dro/components/SettingsForm';

  export default {
    name: 'droModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    mixins: [loadDroInitData],
    data() {
      return {
        disabled: false,
        modalView: true,
      };
    },
    components: {
      SettingsForm,
      Loader,
    },
    methods: {
      close() {
        this.$emit('close');
      },
      ...mapActions('dro/session', [
        'setSettings',
        'setStartedAt',
      ]),

    },

    computed: {
      ...mapState('dro/session', [
        'settings',
        'assignee',
        'isSessionStarted',
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),

      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
    },

  };
</script>


// WEBPACK FOOTER //
// src/modules/dashboardModal/components/droModal.vue